







































































import { computed, defineComponent, watch } from '@vue/composition-api';
import IncomeData from './components/income/income-data.vue';
import OverviewData from './components/overview/overview-data.vue';
import RetentionData from './components/retention/retention-data.vue';
import OriginData from './components/origin/origin-data.vue';
import { useIndexModel } from './hooks/index';
import { DashboardsType } from './types';

export default defineComponent({
    components: {
        IncomeData,
        OverviewData,
        RetentionData,
        OriginData
    },
    props: {
        appId: {
            type: String,
            default: ""
        },
        miniGame: {
            type: Object,
            default: () => {}
        }
    },
    setup(props, context) {
        const { tabList, tabActive, getProject } = useIndexModel();
        const gameType = computed(() => {
            return props.miniGame.realizationWayCode
            // return 'iaap'
        })

        function clickNav(item: DashboardsType | any ) {
            // 暂时只有一个tab，点击暂时无反应
            tabActive.value = item.dashboardCode;
        }

        function loadOver() {
            context.emit('loadOver')
        }

        watch(
            () => props.appId,
            async () => {
                // console.log('切换了游戏:', props.appId);
                getProject();
            },
        );

        return {
            loadOver,
            gameType,
            clickNav,
            tabList,
            tabActive
        };
    },
});
